export const ADD_CLIENT_SECRET = 'ADD_CLIENT_SECRET';

export const addClientSecret = (data) => ({
  type: ADD_CLIENT_SECRET,
  data,
});
